// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1isfV","label":"styles_label__10QCJ"};